import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { useTestScripts } from '../../hooks/testScripts';
import type { TestScript, TestScriptPurpose } from '../../types/types';

type Props = {
    label: string;
    purpose: TestScriptPurpose;
    value: number | null | undefined;
    onChange: (value: number | null) => void;
    disabled?: boolean;
};

const TestScriptPicker: React.FC<Props> = ({ label, purpose, value, onChange, disabled }) => {
    const { data: scripts = [], isLoading } = useTestScripts(purpose);
    const selected = scripts.find((script) => script.id === value) ?? null;

    return (
        <Autocomplete<TestScript, false, false, false>
            options={scripts}
            value={selected}
            loading={isLoading}
            disabled={disabled}
            getOptionLabel={(option) => option.name}
            isOptionEqualToValue={(option, current) => option.id === current.id}
            onChange={(_, next) => onChange(next?.id ?? null)}
            renderInput={(params) => <TextField {...params} label={label} size="small" fullWidth />}
        />
    );
};

export default TestScriptPicker;
